module.exports = __webpack_public_path__ + "static/media/jo.44bc0f8b.svg";